document.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (link && link.href && link.href.includes('/products/')) {
        sessionStorage.setItem('lastScrollY', window.scrollY.toString());
    }
});

function verySmoothScrollTo(targetY) {
    const startY = window.scrollY;
    const duration = 1500;
    let startTime = null;

    function animate(currentTime) {
        if (startTime === null) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = 1 - Math.pow(1 - progress, 4);
        window.scrollTo(0, startY + (targetY - startY) * ease);
        if (progress < 1) {
            requestAnimationFrame(animate);
        }
    }
    requestAnimationFrame(animate);
}
window.addEventListener('load', function () {
    const savedY = sessionStorage.getItem('lastScrollY');
    if (savedY) {
        setTimeout(() => {
            verySmoothScrollTo(parseInt(savedY));
            sessionStorage.removeItem('lastScrollY');
        }, 100);
    }
});